var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityCenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.896 49L24.188 48.686C23.4 48.34 5 40.03 5 24.982V11.934C5.0007 10.6783 5.39757 9.45492 6.13408 8.43795C6.87059 7.42098 7.9092 6.66231 9.102 6.27L25 1L40.898 6.27C42.0908 6.66231 43.1294 7.42098 43.8659 8.43795C44.6024 9.45492 44.9993 10.6783 45 11.934V24.982C45 42.136 26.424 48.492 25.632 48.756L24.896 49ZM25 5.194L10.368 10.046C9.96989 10.176 9.62314 10.4287 9.37741 10.7679C9.13168 11.107 8.99957 11.5152 9 11.934V24.982C9 35.97 21.88 43.098 25.094 44.704C28.302 43.414 41 37.508 41 24.982V11.934C41.0004 11.5152 40.8683 11.107 40.6226 10.7679C40.3769 10.4287 40.0301 10.176 39.632 10.046L25 5.194Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2196 30.0671H23.1536C22.6473 30.0593 22.148 29.949 21.6856 29.7427C21.2232 29.5365 20.8075 29.2386 20.4636 28.8671L15.8516 24.0671L18.7336 21.3031L23.2216 25.9831L33.5836 15.6211L36.4116 18.4491L25.8896 28.9711C25.5391 29.3213 25.1227 29.5984 24.6644 29.7866C24.206 29.9747 23.715 30.07 23.2196 30.0671Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityCenter);
export default __webpack_public_path__ + "static/media/security_center.0b4f1269efd00c7d932018b033ae6077.svg";
export { ForwardRef as ReactComponent };